'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* istanbul ignore next */
var withParams = 'lib' === 'web' ? require('./withParamsBrowser').withParams : require('./params').withParams;

exports.default = withParams;


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vuelidate/lib/withParams.js
// module id = 1144
// module chunks = 0